<template>
	<el-container class="layout-container">
		<!-- 左侧菜单 -->
		<el-aside :width="isCollapse ? '64px' : '220px'" class="layout-aside">
			<div class="logo-container" @click="goHome">
				<i class="el-icon-s-home logo-icon"></i>
				<span class="logo-text" v-if="!isCollapse">中科合研OA</span>
				<span class="logo-text-mini" v-else>OA</span>
			</div>
			<el-menu :default-active="activeMenu" :collapse="isCollapse" :collapse-transition="false"
				background-color="#304156" text-color="#bfcbd9" active-text-color="#409EFF" router unique-opened
				class="layout-menu">
				<template v-for="menu in menuList">
					<el-menu-item v-if="!menu.children || menu.children.length === 0" :key="menu.path"
						:index="resolvePath(menu)">
						<i :class="menu.meta.icon" v-if="menu.meta && menu.meta.icon"></i>
						<template slot="title">
							<span>{{ menu.meta ? menu.meta.title : menu.name }}</span>
						</template>
					</el-menu-item>
					<el-submenu v-else :key="menu.path" :index="menu.path">
						<template slot="title">
							<i :class="menu.meta.icon" v-if="menu.meta && menu.meta.icon"></i>
							<span>{{ menu.meta ? menu.meta.title : menu.name }}</span>
						</template>
						<el-menu-item v-for="child in menu.children" :key="child.path"
							:index="resolvePath(menu, child)">
							<i :class="child.meta.icon" v-if="child.meta && child.meta.icon"></i>
							<span>{{ child.meta ? child.meta.title : child.name }}</span>
						</el-menu-item>
					</el-submenu>
				</template>
			</el-menu>
			<div class="aside-copyright" v-if="!isCollapse">© 合肥中科合研健康科技有限公司</div>
		</el-aside>

		<!-- 右侧主区域 -->
		<el-container>
			<el-header class="layout-header">
				<div class="header-left">
					<span class="collapse-btn" @click="toggleCollapse">
						<i :class="isCollapse ? 'el-icon-s-unfold' : 'el-icon-s-fold'"></i>
					</span>
					<el-breadcrumb separator="/" class="header-breadcrumb">
						<el-breadcrumb-item v-for="item in breadcrumbs" :key="item.path">
							{{ item.meta.title }}
						</el-breadcrumb-item>
					</el-breadcrumb>
				</div>
				<div class="header-right">
					<span class="system-name">OA-中科合研办公系统</span>
					<el-popover placement="bottom" width="380" trigger="click" v-model="notiVisible">
						<div class="noti-header">
							<b>消息中心</b>
							<el-button type="text" size="mini" @click="markAllNotiRead"
								v-if="unreadCount > 0">全部已读</el-button>
						</div>
						<div class="noti-list" v-if="notifications.length > 0">
							<div class="noti-item" :class="{ unread: item.isRead === 0 }" v-for="item in notifications"
								:key="item.id" @click="handleNotiClick(item)">
								<div class="noti-title">
									<span class="noti-dot" v-if="item.isRead === 0"></span>
									{{ item.title }}
								</div>
								<div class="noti-content">{{ item.content }}</div>
								<div class="noti-time">{{ item.createTime }}</div>
							</div>
						</div>
						<div class="noti-empty" v-else>暂无消息</div>
						<div class="noti-footer" @click="goNotificationCenter">
							查看全部消息 →
						</div>
						<el-badge slot="reference" :value="unreadCount" :hidden="unreadCount === 0" :max="99"
							class="noti-badge">
							<i class="el-icon-bell noti-bell"></i>
						</el-badge>
					</el-popover>
					<el-dropdown trigger="click" @command="handleCommand">
						<span class="user-dropdown">
							<el-avatar :size="32" icon="el-icon-user-solid"></el-avatar>
							<span class="user-name">{{ realName }}</span>
							<i class="el-icon-arrow-down"></i>
						</span>
						<el-dropdown-menu slot="dropdown">
							<el-dropdown-item command="profile">
								<i class="el-icon-user"></i> 个人信息
							</el-dropdown-item>
							<el-dropdown-item command="password">
								<i class="el-icon-lock"></i> 修改密码
							</el-dropdown-item>
							<el-dropdown-item divided command="logout">
								<i class="el-icon-switch-button"></i> 退出登录
							</el-dropdown-item>
						</el-dropdown-menu>
					</el-dropdown>
				</div>
			</el-header>

			<el-main class="layout-main">
				<router-view />
			</el-main>
		</el-container>

		<!-- 个人信息对话框 -->
		<el-dialog title="个人信息" :visible.sync="profileVisible" width="600px" :close-on-click-modal="false">
			<el-form ref="profileForm" :model="profileForm" :rules="profileRules" label-width="80px">
				<el-form-item label="用户名">
					<el-input v-model="profileForm.username" style="width: 90%;" disabled></el-input>
				</el-form-item>
				<el-form-item label="姓名" prop="realName">
					<el-input v-model="profileForm.realName" style="width: 90%;" placeholder="请输入姓名"></el-input>
				</el-form-item>
				<el-form-item label="部门">
					<el-input v-model="profileForm.deptName" style="width: 90%;" disabled></el-input>
				</el-form-item>
				<el-form-item label="手机号" prop="phone">
					<el-input v-model="profileForm.phone" style="width: 90%;" placeholder="请输入手机号"></el-input>
				</el-form-item>
				<el-form-item label="邮箱" prop="email">
					<el-input v-model="profileForm.email" style="width: 90%;" placeholder="请输入邮箱"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="profileVisible = false">取消</el-button>
				<el-button type="primary" @click="submitProfile" :loading="profileLoading">保存</el-button>
			</div>
		</el-dialog>

		<!-- 修改密码对话框 -->
		<el-dialog title="修改密码" :visible.sync="passwordVisible" width="500px" :close-on-click-modal="false">
			<el-form ref="passwordForm" :model="passwordForm" :rules="passwordRules" label-width="100px">
				<el-form-item label="旧密码" prop="oldPassword">
					<el-input v-model="passwordForm.oldPassword" type="password" style="width: 90%;"
						placeholder="请输入旧密码"></el-input>
				</el-form-item>
				<el-form-item label="新密码" prop="newPassword">
					<el-input v-model="passwordForm.newPassword" type="password" style="width: 90%;"
						placeholder="请输入新密码（至少6位）"></el-input>
				</el-form-item>
				<el-form-item label="确认密码" prop="confirmPassword">
					<el-input v-model="passwordForm.confirmPassword" type="password" style="width: 90%;"
						placeholder="请再次输入新密码"></el-input>
				</el-form-item>
			</el-form>
			<div slot="footer">
				<el-button @click="passwordVisible = false">取消</el-button>
				<el-button type="primary" @click="submitPassword" :loading="passwordLoading">确定</el-button>
			</div>
		</el-dialog>
	</el-container>
</template>

<script>
import { mapGetters } from 'vuex'
import SockJS from 'sockjs-client'
import { Client } from '@stomp/stompjs'
import {
	updateProfile,
	changePassword,
	getInfo,
	getUnreadCount,
	getNotificationPage,
	markNotificationRead,
	markAllRead
} from '@/api'

export default {
	name: 'Layout',
	data() {
		return {
			isCollapse: false,
			profileVisible: false,
			passwordVisible: false,
			profileLoading: false,
			passwordLoading: false,
			notiVisible: false,
			unreadCount: 0,
			stompClient: null,
			notifications: [],
			profileForm: { username: '', realName: '', deptName: '', phone: '', email: '' },
			profileRules: {
				realName: [{ required: true, message: '请输入姓名', trigger: 'blur' }],
				phone: [{ pattern: /^1[3-9]\d{9}$/, message: '请输入正确的手机号', trigger: 'blur' }]
			},
			passwordForm: { oldPassword: '', newPassword: '', confirmPassword: '' },
			passwordRules: {
				oldPassword: [{ required: true, message: '请输入旧密码', trigger: 'blur' }],
				newPassword: [
					{ required: true, message: '请输入新密码', trigger: 'blur' },
					{ min: 6, message: '新密码不能少于6位', trigger: 'blur' }
				],
				confirmPassword: [
					{ required: true, message: '请确认新密码', trigger: 'blur' },
					{
						validator: (rule, value, callback) => {
							if (value !== this.passwordForm.newPassword) {
								callback(new Error('两次密码输入不一致'))
							} else { callback() }
						}, trigger: 'blur'
					}
				]
			}
		}
	},
	computed: {
		...mapGetters(['userInfo', 'perms']),
		realName() { return (this.userInfo && (this.userInfo.nickName || this.userInfo.username)) || '管理员' },
		activeMenu() { return this.$route.path },
		menuList() { return this.filterRoutes(this.$router.options.routes) },
		breadcrumbs() { return this.$route.matched.filter(item => item.meta && item.meta.title) }
	},
	mounted() {
		this.loadUserInfo()
		this.loadUnreadCount()
		this.connectWebSocket()
		// 30秒轮询兜底
		this._unreadTimer = setInterval(() => { this.loadUnreadCount() }, 30000)
	},
	beforeDestroy() {
		if (this.stompClient) { try { this.stompClient.deactivate() } catch (e) {} }
		if (this._unreadTimer) { clearInterval(this._unreadTimer) }
	},
	watch: {
		notiVisible(val) { if (val) this.loadNotifications() }
	},
	methods: {
		// ========== 消息通知（WebSocket 实时推送） ==========
			loadUnreadCount() {
			getUnreadCount().then(res => { this.unreadCount = res.data || 0 }).catch(() => {})
		},
		connectWebSocket() {
			try {
				const token = this.$store.getters.token
				if (!token) return
				const client = new Client({
					webSocketFactory: () => new SockJS('/ws'),
					connectHeaders: {},
					debug: () => {},
					onConnect: () => {
						const userId = this.userInfo && this.userInfo.id
						if (userId) {
							client.subscribe('/user/' + userId + '/unread-count', (msg) => {
								this.unreadCount = parseInt(msg.body) || 0
							})
						}
					},
					onStompError: () => { /* 静默 */ }
				})
				client.activate()
				this.stompClient = client
			} catch (e) { /* WebSocket不可用 */ }
		},
		loadNotifications() {
			getNotificationPage({ pageNum: 1, pageSize: 5 }).then(res => {
				this.notifications = (res.data && res.data.records) || []
			}).catch(() => {})
		},
		handleNotiClick(item) {
			markNotificationRead(item.id).then(() => {
						if (item.isRead === 0) { this.unreadCount = Math.max(0, this.unreadCount - 1) }
						item.isRead = 1
				this.notiVisible = false
				if (item.refType === 'PROCUREMENT') { this.$router.push('/procurement/list') }
				else if (item.refType === 'MAIL') { this.$router.push('/mail/list') }
				else if (item.refType === 'PROJECT') { this.$router.push('/project/list') }
				else if (item.refType === 'WEEKLY_REPORT') { this.$router.push('/report/weekly-list') }
				else if (item.refType === 'MONTHLY_REPORT') { this.$router.push('/report/monthly-list') }
				else if (item.refType === 'ASSET') { this.$router.push('/asset/list') }
				else if (item.refType === 'REIMBURSEMENT' || this.isLegacyReimbursementNotification(item)) { this.$router.push('/reimbursement/list') }
				else if (item.refType === 'SEAL') { this.$router.push({ path: '/seal/list', query: { id: item.refId } }) }
				else if (item.refType === 'POLICY') { this.$router.push({ path: '/policy/list', query: { id: item.refId } }) }
				else if (item.refType === 'WEBSITE_MESSAGE') { this.$router.push({ path: '/website-message/list', query: { id: item.refId } }) }
			}).catch(() => {})
		},
		isLegacyReimbursementNotification(item) {
			if (!item || item.refType) return false
			return ((item.title || '') + (item.content || '')).includes('报销')
		},
		markAllNotiRead() {
			markAllRead().then(() => {
				this.unreadCount = 0
				this.notifications.forEach(item => { item.isRead = 1 })
			}).catch(() => {})
		},
		goNotificationCenter() { this.notiVisible = false; this.$router.push('/notification') },
		loadUserInfo() {
			if (!this.userInfo.username) {
				this.$store.dispatch('GetInfo').catch(() => { this.$store.dispatch('Logout') })
			}
		},
		filterRoutes(routes) {
			const res = []
			routes.forEach(route => {
				if (route.hidden) return
				if (route.path === '/' || route.path === '/login' || route.path === '*') {
					if (route.children) {
						const children = this.filterRoutes(route.children)
						if (children.length > 0) res.push(...children)
					}
					return
				}
				const tmp = { ...route }
				if (tmp.children) {
					tmp.children = this.filterRoutes(tmp.children)
					if (tmp.children.length === 0) return
				}
				if (tmp.meta && tmp.meta.permission) {
					if (!this.hasPermission(tmp.meta.permission)) return
				}
				res.push(tmp)
			})
			return res
		},
		hasPermission(perm) { return !perm || this.perms.includes(perm) },
		resolvePath(parent, child) {
			if (child) return parent.path + '/' + child.path
			if (parent.children && parent.children.length > 0) return parent.path + '/' + parent.children[0].path
			return parent.path
		},
		toggleCollapse() { this.isCollapse = !this.isCollapse },
		goHome() { this.$router.push('/dashboard') },
		handleCommand(command) {
			if (command === 'logout') {
				this.$confirm('确定退出登录吗?', '提示', { confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' })
					.then(() => { this.$store.dispatch('Logout').then(() => { this.$router.push('/login') }) })
					.catch(() => {})
			} else if (command === 'profile') { this.openProfile() }
			else if (command === 'password') { this.openPassword() }
		},
		openProfile() {
			const user = this.userInfo || {}
			this.profileForm = { username: user.username || '', realName: user.nickName || user.realName || '', deptName: user.deptName || '', phone: user.phone || '', email: user.email || '' }
			if (!user.phone && !user.email) {
				getInfo().then(res => { const u = res.data.user || {}; this.profileForm.realName = u.nickName || u.realName || this.profileForm.realName; this.profileForm.deptName = u.deptName || ''; this.profileForm.phone = u.phone || ''; this.profileForm.email = u.email || '' })
			}
			this.profileVisible = true
			this.$nextTick(() => { this.$refs.profileForm && this.$refs.profileForm.clearValidate() })
		},
		submitProfile() {
			this.$refs.profileForm.validate(valid => {
				if (valid) {
					this.profileLoading = true
					updateProfile({ realName: this.profileForm.realName, phone: this.profileForm.phone, email: this.profileForm.email })
						.then(() => { this.$message.success('个人信息修改成功'); this.profileVisible = false; this.profileLoading = false; this.$store.dispatch('GetInfo') })
						.catch(() => { this.profileLoading = false })
				}
			})
		},
		openPassword() {
			this.passwordForm = { oldPassword: '', newPassword: '', confirmPassword: '' }
			this.passwordVisible = true
			this.$nextTick(() => { this.$refs.passwordForm && this.$refs.passwordForm.clearValidate() })
		},
		submitPassword() {
			this.$refs.passwordForm.validate(valid => {
				if (valid) {
					this.passwordLoading = true
					changePassword({ oldPassword: this.passwordForm.oldPassword, newPassword: this.passwordForm.newPassword })
						.then(() => { this.$message.success('密码修改成功，请重新登录'); this.passwordVisible = false; this.passwordLoading = false; this.$store.dispatch('Logout').then(() => { this.$router.push('/login') }) })
						.catch(() => { this.passwordLoading = false })
				}
			})
		}
	}
}
</script>

<style scoped>
.layout-container { height: 100%; }
.layout-aside { background-color: #304156; overflow: hidden; transition: width 0.3s; display: flex; flex-direction: column; }
.logo-container { height: 56px; display: flex; align-items: center; justify-content: center; cursor: pointer; border-bottom: 1px solid rgba(255,255,255,0.1); flex-shrink: 0; }
.logo-icon { font-size: 24px; color: #409eff; margin-right: 8px; }
.logo-text { color: #fff; font-size: 16px; font-weight: 600; white-space: nowrap; }
.logo-text-mini { color: #fff; font-size: 18px; font-weight: 700; }
.layout-menu { flex: 1 1 auto; min-height: 0; overflow-y: auto; border-right: none; }
.aside-copyright {
	flex-shrink: 0;
	padding: 12px 10px;
	text-align: center;
	font-size: 12px;
	line-height: 1.6;
	color: rgba(255,255,255,0.45);
	border-top: 1px solid rgba(255,255,255,0.08);
	word-break: break-all;
}
.layout-header { background-color: #fff; border-bottom: 1px solid #e6e6e6; display: flex; align-items: center; justify-content: space-between; padding: 0 20px; height: 56px; }
.header-left { display: flex; align-items: center; }
.collapse-btn { font-size: 22px; cursor: pointer; color: #666; padding: 0 10px; transition: color 0.3s; }
.collapse-btn:hover { color: #409EFF; }
.header-breadcrumb { margin-left: 12px; }
.header-right { display: flex; align-items: center; }
.system-name { font-size: 16px; font-weight: 600; color: #333; margin-right: 24px; }
.user-dropdown { display: flex; align-items: center; cursor: pointer; color: #666; }
.user-name { margin: 0 6px; font-size: 14px; }
.layout-main { background-color: #f0f2f5; padding: 20px; min-height: calc(100vh - 60px); overflow-y: auto; }
.layout-menu:not(.el-menu--collapse) { width: 220px; }
.noti-bell { font-size: 22px; color: #666; cursor: pointer; }
.noti-bell:hover { color: #409EFF; }
.noti-badge { margin-right: 20px; }
.noti-badge ::v-deep .el-badge__content { top: 14px; right: 8px; }
.noti-header { display: flex; justify-content: space-between; align-items: center; padding-bottom: 10px; border-bottom: 1px solid #eee; margin-bottom: 8px; }
.noti-list { max-height: 320px; overflow-y: auto; }
.noti-item { padding: 10px 8px; border-radius: 4px; cursor: pointer; border-bottom: 1px solid #f5f5f5; transition: background 0.2s; }
.noti-item:hover { background: #f0f5ff; }
.noti-item.unread { background: #fafafa; }
.noti-title { font-size: 14px; font-weight: 600; color: #333; display: flex; align-items: center; }
.noti-dot { width: 6px; height: 6px; border-radius: 50%; background: #F56C6C; margin-right: 6px; flex-shrink: 0; }
.noti-content { font-size: 12px; color: #999; margin-top: 4px; overflow: hidden; text-overflow: ellipsis; white-space: nowrap; }
.noti-time { font-size: 11px; color: #ccc; margin-top: 2px; }
.noti-empty { text-align: center; padding: 20px; color: #ccc; }
.noti-footer { text-align: center; padding: 8px; color: #409EFF; font-size: 13px; cursor: pointer; border-top: 1px solid #eee; margin-top: 8px; }
.noti-footer:hover { color: #66b1ff; }
</style>
